import _ from 'underscore';
import Util from '../util/Util';
import FCC from './FCC';
import MultiZone from '../data/processor/MultiZone';
import Pros from './Pros';
import Constants from '../util/Constants';

const Recommendation = {


  recommendationRequest(_config) {
    if (!_config || !_config.requester || !_config.productId || !_config.zone) {
      return false;
    }

    const config = _.defaults({}, _config, {
      visitorId: Util.visitorId(),
      countryCode: Util.countryCode(),
      zipCode: Util.zipCode(),
      stateCode: Util.stateCode(),
      customerId: Util.customerId(),
    }, _config.params);

    if (!config.timeout) {
      config.timeout = 15000;
    }
    return config;
  },

  /**
     *
     * @param opts = {
     *      config:{
     *           requester,  //mandatory
     *           productId,   //mandatory
     *           zone      //mandatory
     *      },
     *      properties:{}
     * }
     * @returns {Promise}
     */
  getRecommendations({ config, properties }) {
    return new Promise((resolve, reject) => {
      const request = this.recommendationRequest(config);

      if (!request) {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({
          error: 'Recommendation getRecommendations parameters are not correct',
          opts: config,
        });
        return;
      }

      Pros.getRecommendations(request)
        .done((response) => {
          if (Util.needFccRecommendation({ config, properties, response })) {
            resolve(FCC.getRecommendations(request, properties));
          } else {
            resolve(MultiZone.recommendation(config, response));
          }
        }).fail((x, t, m) => {
          if (Util.needFccRecommendation({ config, properties })) {
            resolve(FCC.getRecommendations(request, properties));
          } else {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({
              error: `${t},message:${m.message} loading: ${Constants.PATH_RTO_RECOMMENDATIONS}`,
              config,
            });
          }
        });
    });
  },

};


export default Recommendation;
